import { Injectable } from '@angular/core';

declare const $: any;

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

constructor() { }

success(message: string) {
  this.showNotification('success', message);
}

error(message: string) {
  this.showNotification('danger', message);
}

warning(message: string) {
  this.showNotification('warning', message);
}

message(message: string) {
  this.showNotification('info', message);
}

displayBody({
  message, 
  header, 
  htmlBodyMessage, 
  action
}: { 
  message: string, 
  header: string, 
  htmlBodyMessage: string, 
  action: Function
}): void {
  this.showNotificationWithBody({
    message, 
    header, 
    htmlBodyMessage, 
    action // ako se klikne dugme
  });
}

private showNotificationWithBody({
  message, 
  header, 
  htmlBodyMessage, 
  action
}: { message: string, header: string, htmlBodyMessage: string, action: Function}) {

  const type = 'info';
  $.notify({
      icon: 'notifications',
      message: message,
      header: header,
      body: htmlBodyMessage
  }, {
      type: type,
      timer: null,
      placement: {
          from: 'top',
          align: 'right'
      },
      template: `
<div 
  data-notify="container"
  class="alert alert-info alert-with-icon" role="alert">
  <button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">
    <i class="material-icons">close</i>
  </button>

  <div class="notify-header">
    <strong data-notify="title">${header}</strong>
  </div>
  <div class="notify-body" data-notify="message">
    ${message}
  </div>
  <div class="notify-footer">
    <button class="btn btn-primary" data-notify="action1">Action 1</button>
    <button class="btn btn-secondary" (click)="${action}" data-notify="action2">Action 2</button>
  </div>

  <div class="progress" data-notify="progressbar">
    <div 
      class="progress-bar progress-bar" 
      role="progressbar" 
      aria-valuenow="0" 
      aria-valuemin="0" 
      aria-valuemax="100" 
      style="width: 0%;">
      
    </div>
  </div>
</div>
      `,
      /*
      template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">  
        <i class="material-icons">close</i></button>' +
        '<div class="notify-header"><strong data-notify="title">{1}</strong></div>' +
        '<div class="notify-body" data-notify="message">{2}</div>' +
        '<div class="notify-footer">' +
          '<button class="btn btn-primary" data-notify="action1">Action 1</button>' +
          '<button class="btn btn-secondary" data-notify="action2">Action 2</button>' +
        '</div>' +
        '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" 
          role="progressbar" aria-valuenow="0" 
          aria-valuemin="0" aria-valuemax="100" 
          style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
      '</div>',
      */
      // Mape za dodatne parametre
      title: header,
      message: htmlBodyMessage,
  });
}


private showNotification(type: any, message: any) {
  $.notify({
      icon: 'notifications',
      message: message
  }, {
      type: type,
      timer: 3000,
      placement: {
          from: 'bottom',
          align: 'right'
      },
      template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
      '</div>'
  });
}

}
